/** Copy de professor (persona Claude / Teca). Quem nunca ouviu falar da LGPD. */
const chip = (word, tip) => ({ word, tip });

function aula(kicker, explain, example, why, terms, learn = []) {
  return { kicker, explain, example, why, terms, learn };
}

export const DIDATICA = {
  'escudo-estelar:1': aula(
    'Missão · 20 minutos',
    'Na Padaria Estrela, o caderno de encomendas tem nome, telefone e o pão que cada pessoa pediu. Isso não é papel da loja. É a vida de gente. No Brasil existe uma lei que protege essa informação: a LGPD. Nestes 20 minutos você sai sabendo o que conta como dado, quem é o dono, que aceite não é a única chave, e o que fazer quando a pessoa pede. Eu te levo slide a slide. Sem juridiquês.',
    'Ana no caixa busca o pedido pelo telefone. Carla no suporte lê o mesmo nome no ticket. Rico na retaguarda vê a rua da entrega. Os três já mexem com o tipo de informação que esta lei olha.',
    'Hoje você toca gente de verdade — cliente, colega, você. Este curso é o escudo do seu posto, não um diploma de parede.',
    [
      chip('LGPD', 'Lei brasileira que protege informação de pessoas — clientes, colegas, você.'),
      chip('Teca', 'Eu. Robô da casa. Te levo pelos 20 minutos sem enrolação.'),
    ],
    [
      'O que é a LGPD, em uma frase de padaria.',
      'Que o curso é passo a passo, sem juridiquês.',
      'Que o certificado no fim é interno — não é carimbo da ANPD.',
    ],
  ),

  'escudo-estelar:2': aula(
    'Gancho · a Vaza entrou',
    'Alguém levantou para o café e deixou a tela da retaguarda aberta. Uma lista de delivery estava ali: nome, telefone, rua. Copiar isso não é pegar um arquivo. É levar a vida de quem comprou pão. A gente chama essa vilã de Vaza. Ela não precisa de hacker se a porta ficou aberta.',
    'Rico da retaguarda foi ao banheiro sem bloquear. Um entregador viu a lista na tela. Não precisou de senha. Precisou de um minuto.',
    'A sua tela é a porta da padaria. Bloquear agora custa um segundo. Depois, custa gente.',
    [
      chip('Vaza', 'O vazamento com cara de personagem. Entra pela porta que a gente esquece aberta.'),
      chip('Lista de delivery', 'Nome, telefone e endereço juntos já apontam para uma pessoa.'),
    ],
    [],
  ),

  'escudo-estelar:3': aula(
    'Mini-aula · o que a lei cobre',
    'Se dá para saber que aquele pedido é da Maria, essa informação é dela. CPF, claro. Também e-mail, foto do crachá, o áudio no WhatsApp do suporte, o pedido do João da mesa 4. A lei chama isso de dado pessoal: informação ligada a uma pessoa que a gente identifica ou consegue identificar. Se ninguém, com esforço razoável, consegue desfazer o anonimato, aí sim sai da lei. Número solto de coxinhas vendidas, sem gente colada, não entra.',
    'No caixa, Ana busca o pedido digitando o telefone. Aparece João, o endereço e o que ele pediu. Isso já é dado pessoal. Não precisa de CPF na tela para a lei olhar.',
    'Você vê isso o dia inteiro. Saber o nome certo evita o erro de achar que só documento oficial conta.',
    [
      chip('Dado pessoal', 'Qualquer informação que dá para saber de quem é.'),
      chip('Identificável', 'Ainda que o nome não esteja na linha: telefone + pedido já apontam a pessoa.'),
    ],
    [
      'Se dá para saber quem é, é dado pessoal.',
      'CPF não é o único jeito de identificar.',
      'Pedido com nome e telefone já entra na lei.',
    ],
  ),

  'escudo-estelar:4': aula(
    'Mini-aula · mexer é tratar',
    'A lei não espera o dado ir para um cofre digital. Anotar no papel, buscar na tela, mandar no grupo, imprimir, usar num gráfico, apagar: cada gesto conta. A lei chama isso de tratamento. Se você mexeu, ela olha. Print da retaguarda no grupo da loja não é fofoca. É tratamento. Guardar e apagar também são.',
    'Carla do suporte tira um print com nome e telefone e manda no Slack da loja para o colega ver o erro. Interno, rápido, de boa intenção. Mesmo assim é tratamento de dado pessoal.',
    'Você trata dado várias vezes por hora. O grupo da loja não é um cofre.',
    [
      chip('Tratamento', 'Qualquer uso: coletar, usar, guardar, compartilhar, apagar.'),
      chip('Print no grupo', 'Compartilhar internamente também é tratar. A lei não pede plateia externa.'),
    ],
    [
      'Mexer no dado já é tratamento.',
      'Mandar print interno também conta.',
      'Apagar é tratamento — a lei olha o ciclo inteiro.',
    ],
  ),

  'escudo-estelar:5': aula(
    'Mini-aula · quem é o dono',
    'O caderno da padaria não dona a Maria. A Maria dona o caderno dela. A lei chama a pessoa de titular: dona do dado. Quem decide o para quê, no dado do cliente da loja, em geral é o restaurante: o controlador. Quem trata por conta dele, no contrato, muitas vezes somos nós: o operador. Dado de funcionário Altec é outro chapéu. Aí a Altec é controladora. Dois chapéus. Mesma regra: respeito.',
    'Na retaguarda, o endereço da entrega é do cliente da Padaria Estrela. A Altec opera esse dado para a loja funcionar. Já o e-mail do crachá da Ana é da relação de trabalho com a Altec. Outro dono do para quê.',
    'Saber o chapéu evita o erro de achar que a empresa dona a pessoa. Você usa. Não dona.',
    [
      chip('Titular', 'A pessoa. Dona do dado. A lei protege ela.'),
      chip('Controlador', 'Quem decide o para quê. No cliente da loja, em geral o restaurante. No funcionário Altec, a Altec.'),
      chip('Operador', 'Quem trata por conta do controlador, no contrato. Muitas vezes, a Altec no dado do cliente.'),
    ],
    [
      'O dono do dado é a pessoa, não a Altec.',
      'No cliente da loja, a Altec costuma operar.',
      'No dado de funcionário, a Altec controla.',
    ],
  ),

  'escudo-estelar:6': aula(
    'Mini-aula · quatro pedras',
    'A padaria não compra farinha demais nem abre o forno sem motivo. Com dado é a mesma lógica. Pegue só o que precisa. Use só para o motivo certo. Cuide para não vazar. Consiga mostrar que cuidou. A lei tem dez ideias assim, os princípios. Você não precisa decorar os dez nomes hoje. Segura estas quatro pedras e a casa não cai.',
    'Marina do RH pede foto do documento no grupo para um cadastro que só precisava de nome e e-mail. Farinha demais. A Vaza agradece o saco aberto.',
    'Antes de criar campo, print ou planilha: estas quatro pedras cabem numa respiração.',
    [
      chip('Princípios', 'Dez ideias da lei que seguram o tratamento. Hoje bastam: preciso, motivo certo, seguro, dá para provar.'),
      chip('Provar', 'Não basta ter cuidado. Precisa conseguir mostrar o cuidado.'),
    ],
    [
      'Só o necessário, só o motivo certo.',
      'Cuidar para não vazar.',
      'Conseguir mostrar que cuidou.',
    ],
  ),

  'escudo-estelar:7': aula(
    'No posto · três hábitos',
    'Antes do café, três gestos baratos salvam a padaria. Bloqueia a tela quando levantar. Não manda dado de cliente no grupo. Não leva planilha no pendrive da mochila. Não é recado de TI. É o jeito de não convidar a Vaza. O resto da missão aprofunda. Estes três você faz hoje.',
    'Ana no caixa trava a tela e vai ao banheiro. Rico não manda a lista de delivery no WhatsApp da turma. Carla não baixa a planilha para o notebook de casa. Três postos. Mesma tranca.',
    'Se só uma coisa ficar: tela bloqueada. O resto desta aula cabe em cima disso.',
    [
      chip('Tela bloqueada', 'A porta mais barata contra a Vaza. Um atalho. Sempre.'),
      chip('Pendrive da mochila', 'Levar a padaria para casa é abrir outra porta, sem alarme.'),
    ],
    [
      'Bloquear a tela ao levantar.',
      'Não mandar dado de cliente no grupo.',
      'Não levar planilha para casa.',
    ],
  ),

  'escudo-estelar:8': aula(
    'Recap · mini-aula 1',
    'Guarda em quatro frases. Se identifica alguém, é dado pessoal. Mexer é tratar. O dono é a pessoa. A Altec às vezes opera o dado do cliente da loja e às vezes controla o dado de funcionário. Tela bloqueada. Isso é o escudo da primeira volta. Nas próximas, as chaves e o que fazer quando a pessoa pede.',
    'Rico fecha a retaguarda, Ana trava o caixa, Carla não printa o ticket no grupo. Os três já estão no recado desta mini-aula.',
    'Se cair um quiz agora, é só isto. Não invente artigo. Responda com o posto.',
    [
      chip('Escudo da volta 1', 'Identifica = pessoal. Mexer = tratar. Dono = a pessoa. Tela bloqueada.'),
      chip('Dois chapéus', 'Operadora no cliente da loja. Controladora no funcionário.'),
    ],
    [
      'Identifica alguém: dado pessoal.',
      'Mexer é tratar; o dono é a pessoa.',
      'Altec opera ou controla, conforme o chapéu.',
    ],
  ),

  'escudo-estelar:9': aula(
    'Quiz · dado pessoal',
    'Lembra da Padaria Estrela: se o telefone aponta para o João, já dá para saber quem é. Isso é dado pessoal. CPF não é o ingresso. Responde com essa ideia. Nada de lei nova nesta tela.',
    'Ana no caixa busca o pedido do João pelo número. A tela mostra nome e telefone. É o mesmo caso da pergunta.',
    'Se vacilar, volte à frase: dá para saber quem é?',
    [
      chip('Dado pessoal', 'Dá para saber de quem é. Telefone + pedido bastam.'),
    ],
    [],
  ),

  'escudo-estelar:10': aula(
    'Quiz · print no grupo',
    'Mandar um print com nome e telefone no Slack da loja é mexer no dado. Mexer é tratar. O grupo interno não é cofre. A lei não espera alguém de fora ver. Responde com isso.',
    'Carla do suporte manda o print para o turno da noite resolver. Boa intenção. Continua tratamento.',
    'Se a opção falar só conversa, desconfia. Conversa com dado de gente ainda é tratamento.',
    [
      chip('Tratamento', 'Compartilhar internamente também conta.'),
    ],
    [],
  ),

  'escudo-estelar:11': aula(
    'Mini-aula · as dez chaves',
    'Muita gente acha que proteger dado é só pedir um aceite no totem. Não. A padaria não pede assinatura para emitir a nota, nem para pagar o salário. A lei tem dez chaves para tratar dado. Consentimento é uma. NFC-e com CPF, folha de pagamento e log de segurança quase nunca andam nessa chave. Você não escolhe a chave no chute. A empresa combina a chave certa. Você não fura.',
    'O cliente pede CPF na nota. Ana emite. Ninguém marca aceito no lugar dele. A chave aqui é obrigação da nota, não o cookie do totem.',
    'Se alguém disser LGPD é o aceite, você já sabe responder: é uma chave. Tem mais nove.',
    [
      chip('Consentimento', 'Uma das dez chaves. Aceite livre, informado, para um fim. Não cobre tudo.'),
      chip('Dez chaves', 'As dez bases da lei. Sem inventar uma décima primeira.'),
    ],
    [
      'Consentimento é uma chave, não a única.',
      'Nota, folha e log quase nunca andam no aceite.',
      'Você não inventa a chave no caixa.',
    ],
  ),

  'escudo-estelar:12': aula(
    'Mini-aula · chaves da casa',
    'Três chaves aparecem o tempo todo na Altec. Emitir nota, guardar folha, cumprir regra: obrigação legal. Entregar o delivery que a pessoa pediu: contrato. Melhorar o produto sem atropelar a pessoa: legítimo interesse, com cuidado. Nenhuma delas é por via das dúvidas. Cada uma pede o dado do motivo, não o cadastro inteiro da cidade.',
    'Rico na retaguarda usa o endereço para a moto chegar. Contrato. Marina usa o CPF da folha porque a lei manda. Obrigação. Pedro quer o celular de quem só passou na calçada. Isso não é chave.',
    'No seu posto, pergunte: qual motivo? Se a resposta for qualquer hora a gente usa, para.',
    [
      chip('Obrigação legal', 'A lei manda: nota, folha, obrigação de verdade. Não é o aceite do totem.'),
      chip('Contrato', 'A pessoa pediu o pão e a entrega. Precisa do dado para cumprir.'),
      chip('Legítimo interesse', 'Dá para usar, com cuidado, nunca por cima da pessoa.'),
    ],
    [
      'Nota e folha: obrigação legal.',
      'Delivery que a pessoa pediu: contrato.',
      'Por via das dúvidas não é chave.',
    ],
  ),

  'escudo-estelar:13': aula(
    'Mini-aula · as outras sete',
    'Ainda cabem sete chaves na mesma caixa, em uma respiração. Política pública. Pesquisa de órgão de pesquisa. Processo na Justiça. Proteger a vida. Cuidar da saúde no papel certo. Proteção ao crédito. E os passos antes do contrato, quando a pessoa pede. Você não decora inciso. Você sabe que existem. E que nenhuma é porque o marketing quis um extra.',
    'Criança com alergia grave na Padaria Estrela: a cozinha precisa saber para não matar. Isso puxa proteger a vida, não um aceite no mural. Canal da operação, não o grupo da família.',
    'Se a chave não for óbvia, você não inventa. Encaminha. A aula que vem diz para quem.',
    [
      chip('Proteger a vida', 'Chave estreita: perigo real à pessoa, não desculpa para guardar demais.'),
      chip('As dez juntas', 'Consentimento + as três da casa + estas sete. Só estas. Sem criatividade.'),
    ],
    [
      'Existem dez chaves, não só aceite.',
      'Proteger a vida e a saúde são chaves próprias.',
      'Não cobra decoreba: cobra não inventar.',
    ],
  ),

  'escudo-estelar:14': aula(
    'Alerta · o que você não faz',
    'Você não inventa a chave. Não marca aceito no lugar do cliente. Não desliga a coleta de CPF na nota porque a LGPD mandou: a nota é obrigação legal. A lei não pediu para a padaria parar de emitir documento. Pediu para tratar com motivo e com cuidado. Chute de base é a Vaza de gravata.',
    'Um cliente apressado pede para Ana clicar o aceite no totem por ele. Ela não clica. Quem consente é a pessoa, se a chave for essa. Na nota, o caminho é outro.',
    'Se a pressão for resolve logo, o recado é este X: não inventa, não clica pelos outros.',
    [
      chip('Inventar base', 'Chute de chave não segura tratamento. Para e pergunta.'),
      chip('Aceite pelos outros', 'Consentimento é da pessoa. Você não marca no lugar dela.'),
    ],
    [
      'Não inventar a chave.',
      'Não clicar aceite pelos outros.',
      'Não desligar CPF da nota por medo da LGPD.',
    ],
  ),

  'escudo-estelar:15': aula(
    'Mini-aula · pedir menos',
    'Se o delivery precisa de endereço, não pede RG. Se o suporte precisa do número do pedido, não pede foto do documento no grupo. Menos dado, menos Vaza. Antes de criar campo novo na tela, pergunta: eu preciso mesmo disso? A pedra preciso da primeira volta mora aqui. Por via das dúvidas é a frase da Vaza.',
    'Carla no suporte quer a selfie com documento para achar um pedido que já tem código e telefone. Farinha demais. O código resolve. A selfie vira alvo.',
    'Cada campo a mais é uma porta a mais. Você fecha a porta não criando o campo.',
    [
      chip('Pedir menos', 'Só o dado do motivo. Extra é risco sem chave.'),
      chip('Campo novo', 'Antes de nascer na tela: precisa mesmo?'),
    ],
    [
      'Delivery precisa de endereço, não de RG.',
      'Suporte precisa do pedido, não da foto do documento.',
      'Por via das dúvidas não é motivo.',
    ],
  ),

  'escudo-estelar:16': aula(
    'Recap · mini-aula 2',
    'Dez chaves. Consentimento é uma. Na casa, as que mais andam são obrigação legal, contrato e legítimo interesse com cuidado. Você não escolhe a chave no chute. Trata só o necessário. Não fura o que a empresa já combinou. Não marca aceite pelos outros. Não desliga a nota por medo.',
    'Ana emite a NFC-e com CPF sem pedir cookie. Rico não pede RG para a moto sair. Os dois já passaram nesta volta.',
    'O quiz agora cobra isto, não inciso. Motivo certo, dado mínimo.',
    [
      chip('Dez chaves', 'Consentimento é uma. Sem décima primeira inventada.'),
      chip('Só o necessário', 'A chave certa não autoriza o cadastro inteiro da cidade.'),
    ],
    [
      'Dez chaves; aceite é uma.',
      'Nota, contrato e interesse legítimo andam na casa.',
      'Sua função: só o necessário, sem furar o combinado.',
    ],
  ),

  'escudo-estelar:17': aula(
    'Quiz · nota fiscal',
    'Emitir a nota com CPF não espera o aceite de cookies no totem. A chave é obrigação legal. Consentimento não segura a nota. Responde com isso. Sem lei nova.',
    'Ana no caixa pergunta se o cliente quer CPF na NFC-e. Ele quer. Ela emite. Ninguém abre o banner de cookie para isso.',
    'Se a opção misturar menor ou aceite, desvia. A pergunta é a nota.',
    [
      chip('Obrigação legal', 'A nota anda nesta chave, não no aceite do totem.'),
    ],
    [],
  ),

  'escudo-estelar:18': aula(
    'Quiz · por via das dúvidas',
    'Juntar o celular de todo mundo que passou na loja por via das dúvidas não é chave. Legítimo interesse não cobre tudo. Só o necessário, com motivo. Apagar depois não conserta a coleta sem chave.',
    'O marketing pede para o caixa anotar o número de quem só olhou a vitrine. Ana não anota. Não houve pedido, não houve motivo.',
    'A frase por via das dúvidas é o sorriso da Vaza. Marca a opção que recusa isso.',
    [
      chip('Só o necessário', 'Sem motivo, não pega. Guardar pouco depois não lava a coleta.'),
    ],
    [],
  ),

  'escudo-estelar:19': aula(
    'Mini-aula · a pessoa pede',
    'A qualquer momento a Maria pode perguntar: o que vocês têm de mim? Pode pedir para corrigir o nome. Para apagar o que não precisa. Para saber com quem a padaria compartilhou. Para tirar o aceite que ela deu, se a chave foi essa. A lei chama isso de direitos do titular. Ela manda. Você não discute se o canal foi Instagram, caixa ou WhatsApp. O pedido vale. O que você faz com ele vem no próximo slide.',
    'Uma cliente manda no Direct da Padaria Estrela: quero ver o que vocês têm. Não é fofoca. É pedido. Ana não responde com a planilha. Encaminha.',
    'Se chegar hoje, você já reconhece: isto é a pessoa mandando na lei.',
    [
      chip('Direitos do titular', 'Ver, corrigir, apagar o excesso, saber com quem foi, tirar o aceite. A qualquer momento.'),
      chip('Qualquer canal', 'Caixa, Instagram, WhatsApp: o pedido vale. O fluxo é que muda a mão.'),
    ],
    [
      'A pessoa pode pedir o que a empresa tem dela.',
      'Pode corrigir, pedir o excesso embora, saber o compartilhamento.',
      'O canal de entrada não anula o pedido.',
    ],
  ),

  'escudo-estelar:20': aula(
    'Mini-aula · você encaminha',
    'Chegou o pedido. Você não apaga. Não exporta. Não inventa prazo. Encaminha para o canal do Encarregado. Anota data e hora. Confirma que chegou. O Encarregado é o ponto de contato da pessoa e da autoridade. Você é a porta de entrada, não o juiz do dado. Resolver no grupo da loja é a Vaza de uniforme.',
    'Carla no suporte recebe me apaga de tudo no WhatsApp. Ela anota hora, encaminha, não mexe no cadastro. Confirma para a pessoa que o pedido entrou no canal certo.',
    'Se a pressão for resolve agora, o recado é este: encaminha. A mão que mexe é o fluxo oficial.',
    [
      chip('Encarregado', 'Ponto de contato da pessoa e da ANPD. Também orienta a gente. Canal, não mágica.'),
      chip('Não mexe', 'Recebeu, não apaga, não exporta, encaminha, confirma.'),
    ],
    [
      'Pedido de titular: encaminha, não resolve no grupo.',
      'Anota data e hora; confirma que chegou.',
      'Você não apaga nem exporta por conta.',
    ],
  ),

  'escudo-estelar:21': aula(
    'Mini-aula · apagar não é sempre',
    'A pessoa pede para apagar. Às vezes dá. Às vezes a nota fiscal ainda precisa existir. Às vezes um processo na Justiça segura o dado. A lei manda guardar quando há obrigação. Quem decide o pode apagar não é o grupo da loja. Encaminha. O fluxo olha o que é excesso e o que a lei segura. Apagar no chute pode ser furar a nota e ainda assim não atender a pessoa.',
    'João pede para sumir de tudo. Rico na retaguarda vê NFC-e com CPF. Ele não apaga a nota. Encaminha. Quem lê obrigação e excesso não é o turno da noite.',
    'Bom coração não substitui o fluxo. Encaminhou: você fez a sua parte hoje.',
    [
      chip('Apagar o excesso', 'Dado desnecessário ou irregular pode sair. Nota e obrigação, não.'),
      chip('Obrigação de guardar', 'Nota, processo, dever legal. O grupo da loja não corta isso.'),
    ],
    [
      'Pedido de apagar se encaminha.',
      'Nota e processo podem obrigar a guardar.',
      'O grupo da loja não decide o pode apagar.',
    ],
  ),

  'escudo-estelar:22': aula(
    'Mini-aula · decisão de máquina',
    'Às vezes um sistema sozinho decide coisa que mexe com a pessoa: bloqueio, fila, crédito. Ela pode pedir revisão. Você não fecha a porta com foi o robô, não tem jeito. Encaminha. No curso da nebula a gente aprofunda. Aqui o hábito cabe numa frase: gente revisa gente. Máquina não é muro.',
    'O cadastro da Maria trava no caixa. Ana não diz foi o sistema. Anota o pedido de revisão e manda ao canal. A cliente não sai da loja sem porta.',
    'Se ouvir foi o algoritmo, você já sabe: isso não é resposta. É recusa disfarçada.',
    [
      chip('Revisão humana', 'Decisão só de máquina que mexe com a pessoa pode ser revista. Você não tranca a porta.'),
      chip('Foi o robô', 'Frase proibida no posto. Encaminha a revisão.'),
    ],
    [
      'Decisão só de máquina pode ser revista.',
      'Não responder foi o robô.',
      'Encaminha o pedido de revisão.',
    ],
  ),

  'escudo-estelar:23': aula(
    'Alerta · golpe no pedido',
    'Cuidado com o golpe. Alguém se passando pelo cliente pede me manda tudo que vocês têm. Identidade primeiro. Encaminha. Não anexa a planilha no privado. Dado na mão errada é a Vaza. Ser simpático no WhatsApp não prova que é o João. O fluxo oficial existe também para isso.',
    'Um número desconhecido chama Ana: sou o João, manda o extrato. Ela não manda. Encaminha. Pede o caminho de identidade pelo canal certo.',
    'Se a urgência for agora senão eu processo, ainda assim: identidade antes do arquivo.',
    [
      chip('Identidade primeiro', 'Sem prova de quem é, nenhum arquivo sai.'),
      chip('Privado do WhatsApp', 'Não é balcão de extrato. Encaminha.'),
    ],
    [
      'Pedido de dado: identidade primeiro.',
      'Não anexar planilha no privado.',
      'Encaminha; não resolve no chute.',
    ],
  ),

  'escudo-estelar:24': aula(
    'Recap · mini-aula 3',
    'A pessoa manda na lei. Você encaminha. Não apaga por conta. Não entrega dado para quem não provou ser a pessoa. Decisão de máquina não fecha a porta. Isto fecha o escudo. O quiz agora só cobra estes hábitos.',
    'Ana encaminha o me apaga. Carla recusa o extrato no número estranho. Rico não apaga a nota. Três postos, um recado.',
    'Se lembrar só uma linha: encaminha, não resolve sozinho.',
    [
      chip('Encaminha', 'Pedido de titular e golpe se resolvem no canal, não no grupo.'),
      chip('Identidade', 'Arquivo só depois de saber quem é.'),
    ],
    [
      'Pedido de titular se encaminha.',
      'Não apagar sozinho; não entregar sem identidade.',
      'Máquina não é muro: revisão humana.',
    ],
  ),

  'escudo-estelar:25': aula(
    'Quiz · me apaga agora',
    'Pedido no WhatsApp do caixa vale. Você não apaga o cadastro para ficar bem. Encaminha ao canal, anota, não mexe. Ignorar porque é WhatsApp também erra. Sem lei nova: só o hábito da volta 3.',
    'A cliente manda para Ana no caixa. Ana não abre a retaguarda para sumir com a ficha. Encaminha.',
    'A opção certa é a mão no canal, não a mão no botão apagar.',
    [
      chip('Qualquer canal', 'WhatsApp vale. O fluxo é que mexe no dado.'),
    ],
    [],
  ),

  'escudo-estelar:26': aula(
    'Quiz · identidade primeiro',
    'Número desconhecido pedindo extrato não leva arquivo. Encaminha. Identidade primeiro. Cliente sempre tem razão não abre o cofre. Recortar sete dias também entrega dado na mão errada.',
    'O golpe chega no suporte com o nome João. Carla não anexa. Manda ao canal.',
    'Se a opção for manda um pedaço, ainda é a Vaza. Sem identidade, zero arquivo.',
    [
      chip('Identidade primeiro', 'Sem prova de quem é, nenhum extrato sai.'),
    ],
    [],
  ),

  'escudo-estelar:27': aula(
    'Tarefa · o que é pessoal',
    'Marca o que aponta para uma pessoa. Nome, telefone, foto de comprovante com CPF: apontam. Sabor da coxinha mais vendida, sozinho, não identifica ninguém. É a primeira mini-aula em forma de lista. Sem artigo novo.',
    'Na tela da Padaria Estrela, Maria, o número dela e o papel com CPF são gente. A coxinha campeã é cardápio.',
    'Se marcar a coxinha, volta à frase: dá para saber quem é?',
    [
      chip('Dado pessoal', 'Aponta para gente. Coxinha sem pessoa, não.'),
    ],
    [],
  ),

  'escudo-estelar:28': aula(
    'Fecha · o que já caiu',
    'Repete comigo, no ritmo da padaria. Dado pessoal identifica gente. Tratar é mexer. O dono é a pessoa. Consentimento não é a única chave. Pedido se encaminha. Cinco frases. Cabe no bolso. O certificado daqui a dois slides prova que você passou por elas, por dentro da Altec. Não é carimbo de autoridade.',
    'Ana, Carla e Rico dizem as cinco em voz alta no encerramento do turno. Não é teatro. É memória de posto.',
    'Se uma frase escapar, é esta: encaminha. O resto se apoia nela.',
    [
      chip('Cinco frases', 'Pessoal, tratar, dono, chaves, encaminha.'),
      chip('Prova interna', 'O certificado guarda quem, quando, o quê, se passou. Não é diploma da ANPD.'),
    ],
    [],
  ),

  'escudo-estelar:29': aula(
    'Hábitos · ouro do escudo',
    'Quatro gestos de ouro. Bloqueia a tela. Não manda dado de cliente no grupo. Não leva planilha para casa. Viu pedido de titular: encaminha. Isto é o que a Padaria Estrela faria de manhã, antes do primeiro pão. O cofre, daqui a alguns dias, sobe o nível: senha, saúde, alarme. Não faça os três cursos hoje. Deixa descansar.',
    'Ana trava. Carla não printa. Rico não leva o CSV. Os três encaminham o Direct da Maria. Turno fechado.',
    'Leva estes quatro para o posto amanhã. O certificado só registra. O hábito segura.',
    [
      chip('Hábitos de ouro', 'Tela, grupo, mochila, encaminha.'),
      chip('Espaço entre cursos', 'O Cofre Quântico espera alguns dias. Memória gosta de descanso.'),
    ],
    [],
  ),

  'escudo-estelar:30': aula(
    'Certificado · prova interna',
    'Escudo no peito. Você concluiu o básico. Este papel diz quem fez, quando fez, o que cobriu e se passou. É prova interna da Altec. Não é credenciamento da ANPD. Não vira diploma de Encarregado. Daqui a alguns dias a gente abre o Cofre Quântico: senha, dado sensível e o que fazer se vazar. Não faça os três hoje.',
    'Ana baixa o PDF, guarda, volta ao caixa. O cliente da Padaria Estrela não vê o certificado. Vê a tela bloqueada.',
    'O valor disto é o hábito, não a arte do PDF. Quem, quando, o quê, passou.',
    [
      chip('Certificado interno', 'Who, when, what, pass. Sem carimbo da ANPD.'),
      chip('Não é diploma', 'Nem a ANPD exige certificado para o Encarregado. Este papel não credencia ninguém.'),
    ],
    [],
  ),

  'cofre-quantico:1': aula(
    'Missão · o cofre sobe',
    'Você já sabe o que é dado pessoal. Agora o nível sobe. Na Padaria Estrela tem coisa que não é só nome na lista: atestado, face na catraca, senha no monitor, o alarme se vazar. Vinte minutos. O cofre não abre com a mesma chave do escudo. Eu te levo. Sem susto, sem poster.',
    'Marina no RH vê um atestado. Pedro na implementação testa uma catraca com face. Rico ainda tem um post-it no monitor. Os três entram neste cofre.',
    'Se o escudo era o que é dado, o cofre é o que dói se cair na rua. Por isso você está aqui hoje.',
    [
      chip('Cofre', 'Sensível, senha, RIPD, Encarregado, incidente. A segunda missão.'),
      chip('20 minutos', 'Três voltas. Quiz depois da aula. Certificado interno no fim.'),
    ],
    [],
  ),

  'cofre-quantico:2': aula(
    'Gancho · post-it no monitor',
    'Nexo achou a senha da retaguarda colada no monitor da Padaria Estrela. A Vaza não precisa hackear se a gente entrega a chave. Senha, dado de saúde, face: o cofre é isto. Alarme de vazamento também. Hoje a gente tranca. O post-it é o convite mais barato do universo.',
    'Rico colou a senha porque o turno da noite esquecia. De manhã o padeiro, o entregador e a Vaza leram juntos. Sem invasão. Com convite.',
    'Se você ainda tem recado de senha na mesa, este slide já começou no seu posto.',
    [
      chip('Post-it', 'Chave do cofre à vista. A Vaza agradece.'),
      chip('Nexo', 'O olhar de quem acha o buraco antes da Vaza.'),
    ],
    [],
  ),

  'cofre-quantico:3': aula(
    'Mini-aula · o tipo sensível',
    'Tem dado que a lei trata mais apertado porque com ele dá para discriminar. Saúde, vida sexual, origem racial, religião, opinião política, dado genético, biometria, filiação a sindicato. A lei chama isso de dado sensível. Não é tudo que a gente gosta de esconder. Salário dói, localização dói, e mesmo assim não entram automaticamente nesse tipo. Grave, sim. O tipo legal, não.',
    'A ficha de alergia da criança no pedido pode ser saúde. O salário da Ana no holerite é pessoal e grave, mas não vira o tipo sensível só por ser secreto. Marina no RH precisa dos dois chapéus certos.',
    'Se alguém disser tudo importante é sensível, você já corrige: é uma lista, não um adjetivo.',
    [
      chip('Dado sensível', 'Tipo legal: saúde, biometria, origem racial, religião, opinião política, genético, vida sexual, sindicato.'),
      chip('Salário', 'Pessoal e grave. Não é automaticamente o tipo sensível.'),
    ],
    [
      'Sensível é um tipo legal, não um adjetivo.',
      'Saúde e biometria entram na lista.',
      'Salário é grave, mas não é automaticamente sensível.',
    ],
  ),

  'cofre-quantico:4': aula(
    'Mini-aula · por que aperta',
    'Com esse tipo dá para discriminar. Por isso as chaves são outras, mais estreitas. Atestado no grupo do RH, foto de catraca com face, ficha de alergia no cardápio: pare e pergunte. Proteger a vida da criança e proteger o dado andam juntos. A cozinha precisa saber. O grupo da família no WhatsApp pessoal, não.',
    'A alergia grave vai para o canal da operação da Padaria Estrela. Não vai para o grupo da turma no celular da casa. Carla do suporte não encaminha a ficha médica no privado.',
    'Se o atalho for o WhatsApp que todo mundo já tem, este é o slide que manda parar.',
    [
      chip('Chaves mais estreitas', 'Dado sensível não anda no aceite de mural nem no grupo da família.'),
      chip('Alergia no pedido', 'Pode ser saúde. Canal da operação, não o celular pessoal.'),
    ],
    [
      'Sensível aperta porque dá para discriminar.',
      'Alergia pode ser saúde: canal certo.',
      'WhatsApp pessoal da equipe não é canal da operação.',
    ],
  ),

  'cofre-quantico:5': aula(
    'Mini-aula · chave do cofre',
    'Senha não é dado de cliente. É a chave do cofre. Token, código do SMS, chave de banco: se vaza, a Vaza entra com o seu crachá. Nunca no Slack. Nunca no post-it. Nunca no print da tela. Apagar a mensagem depois não recolhe o que já foi lido. O alarme vem no próximo hábito. Primeiro: não cola.',
    'Pedro cola a senha do banco de homolog no Slack para o colega testar. Dez segundos, apaga. Alguém já leu. O robô de busca já indexou. O cofre ficou aberto.',
    'Se a pressa for o colega está esperando, o gerenciador de senha é mais rápido que o incidente.',
    [
      chip('Credencial', 'Senha, token, código, chave. Abre o cofre. Não é recado de chat.'),
      chip('Homolog', 'Se tem gente de verdade, vazar ainda dói. Homolog não é desculpa.'),
    ],
    [
      'Senha é chave do cofre, não recado.',
      'Nunca no Slack, no post-it, no print.',
      'Apagar a mensagem não recolhe o vazamento.',
    ],
  ),

  'cofre-quantico:6': aula(
    'Mini-aula · só quem precisa',
    'Você vê o dado que a função pede. Suporte não baixa a base inteira para investigar. Gráfico não precisa de CPF se o número já responde. Colega curioso não é autorização. A gente chama isso de need-to-know: só quem precisa, só o que precisa. Acesso de produção é crachá, não favor.',
    'Carla no suporte pede a base toda para achar um pedido. Rico quase exporta. Os dois param. O ticket tem código. Código basta.',
    'Se o pedido for me passa a produção que eu olho, a resposta é não. Crachá, não favor.',
    [
      chip('Need-to-know', 'Só vê quem a função pede. Curiosidade não é autorização.'),
      chip('Acesso de produção', 'Crachá. Sem empréstimo de login, sem export do banco inteiro.'),
    ],
    [
      'Só vê o dado da função.',
      'Base inteira não é ferramenta de suporte.',
      'Colega curioso não autoriza acesso.',
    ],
  ),

  'cofre-quantico:7': aula(
    'No posto · quatro trancas',
    'Quatro trancas cabem antes do café. Gerenciador de senha. Tela bloqueada. Dois fatores ligado. Se colou credencial no chat por acidente: avisa na hora. Apagar a mensagem não apaga o vazamento. O cofre pede alarme, não borracha. Isto é o seu posto. O caderno de risco vem na próxima volta.',
    'Ana liga o segundo fator no caixa. Pedro joga a senha no gerenciador. Rico avisa no mesmo minuto em que o post-it foi fotografado. Três postos, quatro trancas.',
    'A tranca que mais falha é a quarta: o aviso. Vergonha não fecha incidente.',
    [
      chip('Dois fatores', 'A segunda fechadura. Sem ela, a senha sozinha é convite.'),
      chip('Avisa na hora', 'Credencial no chat é alarme, não borracha.'),
    ],
    [
      'Gerenciador, tela, dois fatores.',
      'Credencial no chat: avisa na hora.',
      'Apagar a mensagem não resolve.',
    ],
  ),

  'cofre-quantico:8': aula(
    'Recap · mini-aula 1',
    'Sensível é um tipo legal, não um adjetivo. Senha é chave do cofre. Só vê quem precisa. Vazar credencial se avisa, não se esconde. Saúde e face apertam. Salário é grave e mesmo assim não entra sozinho na lista. Isto é a primeira tranca. O quiz cobra isto.',
    'Marina não manda atestado no grupo. Pedro não cola token. Carla não baixa a base. Recap feito no posto.',
    'Se sobrar uma frase: avisa, não esconde.',
    [
      chip('Tipo legal', 'Sensível é lista, não feeling.'),
      chip('Alarme, não borracha', 'Credencial vazada se avisa.'),
    ],
    [
      'Sensível é tipo legal, não adjetivo.',
      'Senha é chave; só vê quem precisa.',
      'Vazou credencial: avisa, não esconde.',
    ],
  ),

  'cofre-quantico:9': aula(
    'Quiz · alergia no grupo',
    'A cozinha precisa saber da alergia grave. Isso pode ser dado de saúde. O canal é o da operação, não o WhatsApp pessoal da turma. A lei não manda calar a cozinha. Manda não jogar saúde no celular da casa. Sem artigo novo.',
    'O pedido da criança chega na Padaria Estrela. Rico avisa a cozinha no sistema. Não encaminha a ficha no grupo da família da equipe.',
    'Se a opção for não avisa ninguém, erra duas vezes: a vida e o dado.',
    [
      chip('Dado de saúde', 'Alergia grave pode entrar neste tipo. Canal da operação.'),
    ],
    [],
  ),

  'cofre-quantico:10': aula(
    'Quiz · senha no Slack',
    'Colou a senha e apagou dez segundos depois? Ainda avisa. A mensagem pode ter sido lida ou indexada. Apagar o post não recolhe a chave. Só avisa se alguém responder também erra. Alarme, não borracha.',
    'Pedro sente o frio na barriga e chama segurança no mesmo minuto. Não espera o colega reagir no emoji.',
    'Vergonha não é opção de quiz. Avisa.',
    [
      chip('Alarme, não borracha', 'Apagar o Slack não recolhe a senha.'),
    ],
    [],
  ),

  'cofre-quantico:11': aula(
    'Mini-aula · caderno de risco',
    'Quando o tratamento pode machucar direitos das pessoas, o controlador escreve o risco e o que faz para reduzir. Que dado. Como coleta e protege. O que reduz o dano. A lei chama isso de RIPD. A autoridade pode pedir, principalmente com dado sensível. Você não redige o caderno no intervalo do café. Precisa saber que ele existe e quem aciona.',
    'Pedro quer face na catraca da Padaria Estrela. Isso não nasce num fim de sprint. Nasce com o caderno de risco e com gente de privacidade na sala. Antes do go-live.',
    'Se o projeto novo tiver saúde, face ou score de gente, este caderno entra na conversa. Não depois.',
    [
      chip('RIPD', 'Caderno do controlador: risco do tratamento e o que reduz. A ANPD pode pedir.'),
      chip('Alto risco', 'Face, saúde, score de gente. Não é feature surpresa.'),
    ],
    [
      'RIPD é o caderno de risco do controlador.',
      'A ANPD pode pedir, sobretudo com dado sensível.',
      'Você não redige: você aciona quem redige.',
    ],
  ),

  'cofre-quantico:12': aula(
    'Mini-aula · quem aciona',
    'Você não precisa escrever o RIPD. Precisa avisar quando alguém inventar um tratamento novo de alto risco. Reconhecimento facial na catraca. Score de cliente. Dado de saúde no aplicativo. Projeto novo com dado de gente: chama o Encarregado antes do go-live. Experiência na padaria não é laboratório secreto.',
    'O time quer ligar a câmera do estoque para ver quem pega refrigerante. Pedro para a reunião. Encarregado antes. Face é biometria. Biometria é o tipo apertado.',
    'Se a frase for a gente liga e vê se cola, este slide é o pare.',
    [
      chip('Antes do go-live', 'Face, saúde, score: Encarregado entra cedo, não na sexta da virada.'),
      chip('Tratamento novo', 'Mudou o para quê ou o tipo de dado: avisa. Não é burocracia de poster.'),
    ],
    [
      'Você não redige o RIPD.',
      'Tratamento novo de alto risco: avisa antes.',
      'Face, saúde, score: Encarregado antes do go-live.',
    ],
  ),

  'cofre-quantico:13': aula(
    'Mini-aula · o Encarregado',
    'Tem uma pessoa — ou um time — que a lei pede como ponto de contato. A pessoa titular fala com ele. A autoridade também. Ele orienta a gente. A lei chama isso de Encarregado. Por aí fora dizem DPO. A empresa continua responsável. Ele não come a multa no crachá. Exercer o papel não exige certificado profissional. Este curso também não vira diploma dele.',
    'A Maria da Padaria Estrela quer saber quem trata o dado dela. O caminho não é o Instagram da loja. É o canal do Encarregado. Carla no suporte encaminha, não responde no feeling.',
    'Se alguém disser o DPO assume, você já corrige: canal e orientação. A conformidade é da Altec.',
    [
      chip('Encarregado', 'Canal com titular e ANPD. Orienta o time. Não é o dono da culpa.'),
      chip('Sem diploma mágico', 'O papel não exige certificação. A empresa continua responsável.'),
    ],
    [
      'Encarregado é canal e orientação.',
      'A empresa continua responsável.',
      'Não precisa de certificado profissional para o papel.',
    ],
  ),

  'cofre-quantico:14': aula(
    'Mini-aula · medida de verdade',
    'A lei manda medida de verdade: acesso controlado, registro, backup, criptografia quando couber, gente treinada. Este curso é uma dessas medidas. Badge no LinkedIn não é. Poster na copa não é. O cofre se prova com porta, log e hábito. Não com figurinha.',
    'Rico tem backup. Ana tem acesso só do caixa. Pedro tem log de quem exportou. Marina fez este curso. Quatro medidas. Zero badge de ranking.',
    'Se a conformidade da semana for um selo no Slack, falta o tijolo. Medida é o que segura o dado.',
    [
      chip('Medida de segurança', 'Acesso, registro, backup, gente treinada. O que a lei pede de fato.'),
      chip('Este curso', 'Ação educativa da casa. Prova de quem fez. Não é poster.'),
    ],
    [
      'Segurança é medida, não poster.',
      'Acesso, log, backup, gente treinada.',
      'Badge não prova conformidade.',
    ],
  ),

  'cofre-quantico:15': aula(
    'Mini-aula · sem atalho',
    'Existe regra mais leve para empresa pequena. Prazo dobrado em incidente, alguns deveres menores. A Altec não se desenha nesse tamanho neste curso. Então: prazo cheio, dever cheio. Sem atalho de pequeno porte. Se alguém disser a gente é pequeno, a gente relaxa, este slide é o não.',
    'Sexta, 18h, CSV na Padaria Estrela. O relógio não espera segunda porque o turno é curto. Altec não ganha prazo extra de pequeno porte.',
    'No seu posto, o recado é simples: avisa agora. Quem calcula tamanho e prazo não é o grupo da loja.',
    [
      chip('Agente de pequeno porte', 'Regra mais leve para empresa pequena. A Altec, neste curso, não se desenha assim.'),
      chip('Prazo cheio', 'Incidente: 3 dias úteis. Sem desconto de tamanho.'),
    ],
    [
      'Existe atalho de empresa pequena.',
      'A Altec não se desenha nesse atalho aqui.',
      'Prazo cheio, dever cheio.',
    ],
  ),

  'cofre-quantico:16': aula(
    'Recap · mini-aula 2',
    'RIPD é caderno de risco. Encarregado é canal e orientação. Segurança é medida de verdade, não poster. Altec sem atalho de pequeno porte. Você não redige o caderno. Você aciona. A empresa não terceiriza a culpa no crachá do Encarregado. Isto fecha a segunda tranca.',
    'Pedro para a catraca com face. Marina encaminha a Maria. Rico não conta com prazo de empresa pequena. Recap no posto.',
    'O quiz cobra face, RIPD e responsabilidade da empresa. Sem inciso de surpresa.',
    [
      chip('Quatro pedras do cofre', 'RIPD, Encarregado, medida de verdade, sem atalho.'),
      chip('Antes do go-live', 'Alto risco não estreia escondido.'),
    ],
    [
      'RIPD = caderno de risco.',
      'Encarregado = canal; a empresa responde.',
      'Altec sem atalho de pequeno porte.',
    ],
  ),

  'cofre-quantico:17': aula(
    'Quiz · face no estoque',
    'Câmera com reconhecimento facial no estoque não liga para ver se funciona. Face é biometria. Biometria é o tipo apertado. Chama o Encarregado antes. Aceite no mural da copa não segura. Sem lei nova nesta tela.',
    'O time da Padaria Estrela quer flagrar o refrigerante. Pedro para. Não há go-live de face no feeling.',
    'A primeira ação é parar e chamar, não ligar a câmera.',
    [
      chip('Biometria', 'Face, digital, voz. Tipo sensível. Encarregado antes.'),
    ],
    [],
  ),

  'cofre-quantico:18': aula(
    'Quiz · a culpa da empresa',
    'O Encarregado existe. Isso não tira a responsabilidade da Altec. Ele é canal e orientação. Não come a multa. Certificação dele não muda isso. A empresa continua responsável.',
    'Alguém no suporte diz relaxa, agora é com o DPO. Carla corrige: encaminha para ele, a casa continua no gancho.',
    'Se a opção falar que o DPO assume, é a Vaza de gravata.',
    [
      chip('Responsabilidade', 'Do agente de tratamento — a empresa. Não da pessoa física do Encarregado.'),
    ],
    [],
  ),

  'cofre-quantico:19': aula(
    'Mini-aula · o que é incidente',
    'Nem todo bug é o alarme. Incidente, na regra da autoridade, é um evento adverso confirmado que quebra o sigilo, a integridade, a disponibilidade ou a autenticidade do dado pessoal. Dado de gente em risco de verdade. Tentativa bloqueada ainda não é. Planilha de clientes num canal aberto, sim. O relógio que vem no próximo slide só começa quando se confirma que dado pessoal foi afetado.',
    'A API da Padaria Estrela devolveu o CPF de outro pedido. Confirmado. Gente afetada. Isto é incidente. Um login errado que a tela recusou, ainda não.',
    'Seu papel não é batizar o evento. É avisar cedo para quem confirma.',
    [
      chip('Incidente', 'Evento adverso confirmado que quebra sigilo, integridade, disponibilidade ou autenticidade do dado pessoal.'),
      chip('Confirmado', 'O relógio não anda no feeling. Anda na confirmação de dado pessoal afetado.'),
    ],
    [
      'Incidente é evento confirmado com dado pessoal em risco.',
      'Não é todo bug.',
      'Você avisa; quem confirma é o time.',
    ],
  ),

  'cofre-quantico:20': aula(
    'Mini-aula · três dias úteis',
    'Quando a empresa sabe que dado pessoal foi afetado e há risco relevante, comunica a autoridade e a pessoa em 3 dias úteis. Operadora avisa a controladora na hora. Esconder para resolver primeiro come o prazo. A Altec não ganha prazo dobrado de empresa pequena. Seu papel: avisar agora. Não calcular sozinho se é relevante.',
    'Sexta, 18h, CSV com clientes da Padaria Estrela num canal aberto. Rico não espera segunda. Avisa segurança e Encarregado. O relógio da empresa já acordou.',
    'Se a tentação for segunda a gente vê, este slide é o não. O relógio não respeita expediente.',
    [
      chip('3 dias úteis', 'ANPD e titular, a contar do conhecimento de que dado pessoal foi afetado.'),
      chip('Operadora avisa', 'Quem opera avisa quem controla, sem demora. Você aciona o fluxo, não a autoridade no Gmail.'),
    ],
    [
      '3 dias úteis para ANPD e titular.',
      'Operadora avisa a controladora na hora.',
      'Você avisa agora; não calcula sozinho o risco.',
    ],
  ),

  'cofre-quantico:21': aula(
    'Mini-aula · cinco minutos',
    'Cinco minutos, quatro gestos. Para o sangramento se puder: tira o arquivo do ar, revoga a senha. Não espalha o arquivo para a galera ver. Avisa segurança e Encarregado: o quê, quando, quem, que dado. Segue o roteiro. Não dá entrevista. Você não é porta-voz. É o alarme.',
    'Carla acha o CSV no Slack. Tira do alcance que ela controla. Não baixa para casa. Avisa. Não manda o arquivo de novo para provar.',
    'Provar o buraco descrevendo, não reenviando o tesouro. Isto salva o próximo slide de exemplos.',
    [
      chip('Para o sangramento', 'Revoga, tira do ar, fecha a pasta. Sem viralizar o arquivo.'),
      chip('Recado mínimo', 'O quê, quando, quem, que tipo de dado, quantas pessoas se der para estimar.'),
    ],
    [
      'Para o sangramento se puder.',
      'Não espalha o arquivo.',
      'Avisa segurança e Encarregado; não dá entrevista.',
    ],
  ),

  'cofre-quantico:22': aula(
    'Mini-aula · exemplos da casa',
    'Quatro cenas acendem o alarme. Planilha de clientes no Slack público. Notebook da loja sumiu. Backup no Drive pessoal. A tela devolveu CPF de outro pedido. Tudo isso. Mesmo só homolog, se tiver gente de verdade. A Padaria Estrela não espera o jornal. Avisa.',
    'O notebook do caixa some no intervalo. Ana avisa agora. Não espera achar atrás do forno na segunda. Pode achar. O alarme não espera.',
    'Se a frase for é só homolog, olha se tem pessoa de verdade. Tem? Alarme.',
    [
      chip('Exemplos que acendem', 'CSV aberto, notebook sumido, backup pessoal, CPF trocado.'),
      chip('Homolog com gente', 'Dado de pessoa real não vira exercício. Alarme igual.'),
    ],
    [
      'CSV aberto, notebook sumido, backup pessoal, CPF trocado: alarme.',
      'Homolog com gente de verdade também conta.',
      'Avisa; não espera o jornal.',
    ],
  ),

  'cofre-quantico:23': aula(
    'Mini-aula · ainda não é',
    'Tentativa bloqueada, senha errada, alerta que não confirmou dado pessoal: registra, investiga. Ainda não é o relógio de 3 dias. O relógio começa quando se confirma que dado pessoal foi afetado. Por isso avisar cedo ajuda. Quem confirma é o time, não o feeling do turno. Esconder porque talvez não seja só atrasa a confirmação.',
    'Alguém erra a senha da retaguarda três vezes e a tela bloqueia. Rico registra. Ainda não é o CSV na rua. Se depois se vê que entrou, o time confirma e o relógio anda.',
    'Na dúvida, avisa. Classificar é do fluxo. Calar é da Vaza.',
    [
      chip('Ainda não', 'Tentativa bloqueada e senha errada: registra. Relógio ainda não.'),
      chip('Avisa cedo', 'Quem confirma precisa do alarme cedo, não do feeling tarde.'),
    ],
    [
      'Tentativa bloqueada ainda não é o relógio.',
      'O relógio anda na confirmação de dado pessoal afetado.',
      'Na dúvida, avisa cedo.',
    ],
  ),

  'cofre-quantico:24': aula(
    'Recap · mini-aula 3',
    'Evento confirmado, dado pessoal, risco. 3 dias úteis para a autoridade e para a pessoa. Você avisa na hora. Não esconde. Não viraliza o arquivo. Altec sem prazo de pequeno porte. Isto fecha o cofre. A prova de campo é o recado mínimo, sem reenviar o tesouro.',
    'Sexta à noite, Carla avisa. Não baixa o CSV. Não espera segunda. Recap feito.',
    'Se ficar uma linha: alarme, não borracha.',
    [
      chip('Relógio', '3 dias úteis depois da confirmação. Você aciona agora.'),
      chip('Não viraliza', 'Descreve o buraco. Não reenvia a lista.'),
    ],
    [
      'Confirmado + dado pessoal + risco: incidente.',
      '3 dias úteis; você avisa agora.',
      'Não esconde, não viraliza o arquivo.',
    ],
  ),

  'cofre-quantico:25': aula(
    'Quiz · CSV na sexta',
    'CSV com nome, telefone e CPF num canal aberto, sexta 18h. Primeira ação: tira do alcance que você controla e avisa segurança e Encarregado agora. Esperar segunda come o prazo. Baixar para investigar em casa piora o incidente. Sem lei nova.',
    'Rico vê o arquivo no Slack da Padaria Estrela. Não leva para o fim de semana. Avisa.',
    'O relógio não respeita expediente. A opção certa também não.',
    [
      chip('Avisa agora', 'Sexta 18h ainda é agora. Levar o CSV para casa piora.'),
    ],
    [],
  ),

  'cofre-quantico:26': aula(
    'Quiz · quem fala com a ANPD',
    'Quem comunica a autoridade em 3 dias úteis é o fluxo oficial da empresa. Controlador fala. Operadora avisa o controlador. Você não vira porta-voz no Gmail. Imprensa não dispara o dever. Você aciona. Não discursa.',
    'Carla quer ajudar e quase escreve um e-mail pessoal para a Agência. Para. Encaminha ao Encarregado.',
    'A opção certa é o fluxo. A errada é o herói com Gmail.',
    [
      chip('Fluxo oficial', 'Você aciona. A empresa comunica. Gmail pessoal não é canal da ANPD.'),
    ],
    [],
  ),

  'cofre-quantico:27': aula(
    'Tarefa · recado mínimo',
    'O recado mínimo descreve o buraco: o que aconteceu, quando você soube, que tipo de dado, quantas pessoas se der para estimar. Não cola o print de todos os clientes para provar. Provar reenviando o tesouro é a Vaza outra vez. Sem lei nova: só o hábito dos cinco minutos.',
    'Pedro escreve: CSV no canal aberto, 18h, CPF e telefone, uns 8 mil. Sem anexo da base. Encarregado recebe o mapa, não o ouro.',
    'Se a tentação for anexo para não faltar detalhe, falta o recado. Sobra o incidente.',
    [
      chip('Descreve o buraco', 'O quê, quando, tipo, quantas. Sem reenviar a lista.'),
    ],
    [],
  ),

  'cofre-quantico:28': aula(
    'Fecha · o que já caiu',
    'Sensível é tipo legal. Senha se avisa se vazar. RIPD é caderno de risco. Encarregado é canal. Incidente confirmado: 3 dias úteis, você avisa agora. Cinco frases do cofre. O certificado prova que você passou por elas por dentro da Altec. Não é carimbo da ANPD.',
    'Marina, Pedro e Rico repetem as cinco no fim do turno. Depois descansam. A nebula espera alguns dias.',
    'A frase de bolso: alarme, não borracha.',
    [
      chip('Cinco frases do cofre', 'Tipo legal, senha, RIPD, Encarregado, 3 dias.'),
      chip('Prova interna', 'Who, when, what, pass. Sem diploma da Agência.'),
    ],
    [],
  ),

  'cofre-quantico:29': aula(
    'Hábitos · tranca do cofre',
    'Cinco trancas. Dois fatores. Sem credencial no chat. Sem dado de saúde no WhatsApp pessoal. Projeto novo com face ou saúde: Encarregado antes. Viu vazamento: alarme, não borracha. A Rede Nebulosa, daqui a alguns dias, move o dado entre planetas. Não faça o avançado hoje.',
    'Ana liga o segundo fator. Pedro não cola token. Marina não manda atestado no grupo. Rico avisa o CSV. Cofre trancado.',
    'Leva as cinco para amanhã. O PDF só registra.',
    [
      chip('Trancas', '2FA, chat limpo, saúde no canal certo, Encarregado antes, alarme.'),
      chip('Descanso', 'A nebula espera. Memória gosta de intervalo.'),
    ],
    [],
  ),

  'cofre-quantico:30': aula(
    'Certificado · prova interna',
    'Cofre trancado. Este papel diz quem fez, quando, o que cobriu e se passou. É prova interna da Altec. Não é credenciamento da ANPD. Não vira certificado de Encarregado. Falta a Rede Nebulosa: planilha, nuvem fora do Brasil, decisão de máquina, criança, multa. De novo: não faça o avançado hoje. Deixa descansar.',
    'Pedro baixa o PDF e volta à catraca — ainda sem face, ainda com o Encarregado na conversa. O papel não autoriza feature.',
    'O valor é o alarme no dia. Who, when, what, pass.',
    [
      chip('Certificado interno', 'Prova de trilha da casa. Sem carimbo da ANPD.'),
      chip('Próxima missão', 'Rede Nebulosa depois de uns dias. Fluxo, nuvem, menor, multa.'),
    ],
    [],
  ),

  'rede-nebulosa:1': aula(
    'Missão · a rede move',
    'Escudo e cofre guardam. A rede move. Na Padaria Estrela o pedido sai do caixa, passa na retaguarda, no cardápio, no suporte, num serviço lá fora. Cada pulo é tratamento. Vinte minutos para não mandar a pessoa junto com o arquivo. Eu te levo pela nebula. Sem nuvem mágica.',
    'Ana registra o pedido. Rico exporta para o contador. Carla cola um ticket num chatbot. Pedro testa um disparo com servidor longe. Quatro pulos. Quatro jeitos de levar a Maria embora.',
    'Se o seu dia é mandar arquivo, este curso é o seu posto. Fluxo é produto.',
    [
      chip('Rede', 'Cada pulo do dado é tratamento. Caixa, retaguarda, cardápio, suporte, SaaS.'),
      chip('20 minutos', 'Compartilhar, nuvem, máquina, menor, multa, um caso. Depois, prova interna.'),
    ],
    [],
  ),

  'rede-nebulosa:2': aula(
    'Gancho · a planilha viajou',
    'Nexo viu a viagem. Uma planilha de clientes saiu da Padaria Estrela, passou no e-mail pessoal, entrou num Drive de fornecedor, voltou num grupo. A Vaza não invadiu. A gente convidou. Hoje a gente fecha o fluxo, não só o cadeado. Arquivo que viaja leva gente junto.',
    'Rico mandou o CSV para o Gmail da casa para trabalhar no domingo. Segunda o arquivo já estava no grupo e no fornecedor. Sem hacker. Com convite.',
    'Se o seu atalho é o e-mail pessoal, este gancho já aconteceu com a sua cara.',
    [
      chip('Planilha que viaja', 'Cada hop é tratamento. E-mail pessoal não é cofre.'),
      chip('Convite', 'A Vaza entra quando a gente manda o arquivo. Nem sempre quando ela arromba.'),
    ],
    [],
  ),

  'rede-nebulosa:3': aula(
    'Mini-aula · compartilhar é tratar',
    'Mandar para o contador, para o app de disparo, para o gráfico, para o parceiro da entrega: cada um é um compartilhamento. Precisa de motivo. De contrato quando for operador. De dado mínimo. A lei já ensinou: mexer é tratar. Mandar embora também é. A padaria inteira numa planilha não é teste. É a Maria em cópia carbono.',
    'O contador da Padaria Estrela precisa de nota, não da lista de aniversário do clube infantil. Rico manda o necessário. Não a base toda.',
    'Antes de anexar, três perguntas: motivo, quem recebe, o mínimo. Faltou uma, não manda.',
    [
      chip('Compartilhar', 'Tratamento. Motivo, contrato quando couber, dado mínimo.'),
      chip('Base toda', 'Quase nunca é o mínimo. Teste e parceiro não pedem a padaria inteira.'),
    ],
    [
      'Mandar o dado embora também é tratar.',
      'Precisa de motivo, contrato quando for operador, mínimo.',
      'A base toda quase nunca é o necessário.',
    ],
  ),

  'rede-nebulosa:4': aula(
    'Mini-aula · operador no contrato',
    'Operador não é o cara de TI. É quem trata por conta de quem decide o para quê, no contrato. A Altec é operadora de muito dado de restaurante. O restaurante não larga o dado e reza. A gente também não usa o dado do cliente para um produto novo sem base e sem combinado. Dúvida de produto: Encarregado antes do experimento.',
    'Pedro quer treinar um ranking de cliente fiel com a base da Padaria Estrela, fora do combinado. Para. Isso não é operar o pedido. É outro para quê. Outra conversa.',
    'Dois chapéus, lembrando: no cliente da loja, em geral operamos. No funcionário, controlamos. Nenhum chapéu autoriza experimento escondido.',
    [
      chip('Operador', 'Trata por conta do controlador, no contrato. Não inventa finalidade.'),
      chip('Produto novo', 'Dado de cliente da loja não é laboratório. Encarregado antes.'),
    ],
    [
      'Operador trata no contrato, por conta de quem decide.',
      'A Altec opera muito dado de restaurante.',
      'Produto novo com dado de cliente: Encarregado antes.',
    ],
  ),

  'rede-nebulosa:5': aula(
    'Alerta · três atalhos',
    'Três atalhos da Vaza. CSV no e-mail solto. Encaminhar para o Gmail pessoal para trabalhar no fim de semana. Grupo de WhatsApp com gente que já saiu da empresa. Atalho não é processo. E-mail pessoal não é cofre. Grupo velho é porta sem porteiro.',
    'Carla encaminha o ticket com nome e telefone para o Gmail da casa. Domingo rende. Segunda a Vaza também rendeu. O atalho virou viagem.',
    'Se o fim de semana pedir a padaria na mochila, o recado é não. Segunda ainda existe.',
    [
      chip('E-mail pessoal', 'Não é pasta da empresa. Não é cofre. Não é processo.'),
      chip('Grupo velho', 'Quem já saiu ainda lê. Isso é compartilhar com gente demais.'),
    ],
    [
      'CSV no e-mail solto não é processo.',
      'Gmail pessoal não é cofre.',
      'Grupo com quem já saiu é porta aberta.',
    ],
  ),

  'rede-nebulosa:6': aula(
    'Mini-aula · fora do Brasil',
    'Nuvem em outro país não é só a nuvem. É mandar o dado para outro lugar, com outra regra. A lei chama isso de transferência internacional. Pede adequação, cláusulas-padrão ou outra garantia. Não é está numa sigla famosa, então ok. Quem contrata o serviço pergunta ao jurídico e ao Encarregado antes de colar a base lá. Bonito não é base legal.',
    'O time quer um disparo com servidor nos Estados Unidos. Pedro não cadastra o cartão. Para. Olha cláusula ou adequação. A lista da Padaria Estrela não viaja no feeling.',
    'Se o argumento for todo mundo usa, ainda assim: pedágio da nebula. Encarregado antes.',
    [
      chip('Transferência internacional', 'Dado pessoal saindo do Brasil. Adequação, cláusula-padrão ou outra garantia.'),
      chip('SaaS lá fora', 'Pergunta antes de colar a base. Logo bonito não é garantia.'),
    ],
    [
      'Nuvem fora do Brasil é transferência.',
      'Pede adequação, cláusula ou outra garantia.',
      'Jurídico e Encarregado antes de colar a base.',
    ],
  ),

  'rede-nebulosa:7': aula(
    'No posto · cinco sim',
    'Antes de exportar, cinco sim. Preciso? Quem recebe? Fica no Brasil? Tem contrato? Sei apagar depois? Se faltar um sim, não exporta. Isto é o checklist da nebula no seu posto. Cabe num post-it. Melhor que o post-it da senha.',
    'Rico quer mandar a lista para um parceiro testar. Preciso? Não, o teste pode ser fictício. Já falhou o primeiro sim. O CSV não sai.',
    'Cinco sim é mais rápido do que um incidente de 12 mil nomes. Faz as cinco em voz alta.',
    [
      chip('Cinco sim', 'Preciso, quem recebe, Brasil, contrato, sei apagar. Faltou um: não exporta.'),
      chip('Apagar depois', 'Se não sabe tirar o dado de lá, não manda o dado para lá.'),
    ],
    [
      'Cinco sim antes de exportar.',
      'Faltou um sim: não exporta.',
      'Teste com gente de verdade quase nunca passa no primeiro sim.',
    ],
  ),

  'rede-nebulosa:8': aula(
    'Recap · mini-aula 1',
    'Compartilhar é tratar. Operador trabalha no contrato. E-mail pessoal não é cofre. Nuvem fora do Brasil tem regra. Cinco sim antes de exportar. Isto fecha a primeira nebula. O quiz cobra CSV de teste e servidor lá fora. Sem inciso de surpresa.',
    'Pedro não sobe a lista nos EUA. Rico não manda a base de produção. Carla não usa o Gmail da casa. Recap no posto.',
    'A frase de bolso: cinco sim, ou não sai.',
    [
      chip('Recap da rede', 'Compartilhar = tratar. Contrato. Sem e-mail pessoal. Nuvem tem pedágio. Cinco sim.'),
      chip('Operar ≠ experimentar', 'Finalidade nova pede Encarregado.'),
    ],
    [
      'Compartilhar é tratar.',
      'E-mail pessoal não é cofre; nuvem fora tem regra.',
      'Cinco sim antes de exportar.',
    ],
  ),

  'rede-nebulosa:9': aula(
    'Quiz · CSV de teste',
    'Parceiro pede a base toda para testar. Você não manda o CSV de produção. Dado mínimo, ambiente sem gente de verdade, contrato. Encarregado se for novo. Tirar o CPF e deixar nome, telefone e endereço ainda identifica. Sem lei nova.',
    'A Padaria Estrela não testa integração com a Maria de verdade. Pedro manda massa fictícia. Ou não manda.',
    'Se a opção for apaga o CPF e manda, ainda é a padaria inteira. Não marca.',
    [
      chip('Teste', 'Sem gente de verdade. Sem a base toda. Contrato. Encarregado se for novo.'),
    ],
    [],
  ),

  'rede-nebulosa:10': aula(
    'Quiz · SaaS nos EUA',
    'Servidor fora do Brasil é transferência. Primeiro passo: para. Jurídico e Encarregado olham cláusula ou adequação. Cadastrar o cartão e subir a lista é convidar a Vaza. Logo bonito não é chave. Sem artigo novo nesta tela.',
    'O time da Padaria Estrela se empolga com o disparo. Pedro guarda o cartão. Chama o canal.',
    'A nebula tem pedágio. A opção certa paga o pedágio antes, não depois da lista no ar.',
    [
      chip('Pedágio da nebula', 'Adequação ou cláusula antes da lista viajar.'),
    ],
    [],
  ),

  'rede-nebulosa:11': aula(
    'Mini-aula · revisão humana',
    'Se um sistema sozinho decide coisa que mexe com a pessoa — bloquear cadastro, fila, crédito, cliente risco — ela pode pedir revisão. Você não responde foi o algoritmo. Gente revisa gente. Robô mais um botão de revisão humana. Sempre. A porta não fecha com a palavra sistema.',
    'O caixa trava a Maria. Ana não diz foi o robô. Encaminha a revisão. A cliente continua sendo gente na frente de gente.',
    'Se o time de produto esconde o score no canto da tela, ainda assim: decisão que mexe pede porta de revisão.',
    [
      chip('Decisão só de máquina', 'A pessoa pode pedir revisão. Você não tranca a porta.'),
      chip('Foi o algoritmo', 'Frase proibida. Encaminha a revisão humana.'),
    ],
    [
      'Decisão só de máquina pode ser revista.',
      'Não responder foi o robô.',
      'Encaminha para revisão humana ou canal de privacidade.',
    ],
  ),

  'rede-nebulosa:12': aula(
    'Mini-aula · perfil é tratamento',
    'Montar um rótulo da pessoa — compra à noite, reclama, provável inadimplente — já é tratamento. Precisa de motivo. De dado mínimo. De não discriminar. Score escondido no canto da tela ainda é perfil. A padaria não cola etiqueta na testa da Maria sem motivo e sem cuidado.',
    'A retaguarda mostra uma estrela vermelha: risco. Rico não inventa uma história para a cliente sair. Encaminha se ela pergunta. Não perfila por esporte.',
    'Se o rótulo não tem motivo, não tem chave. Não tem lugar na tela.',
    [
      chip('Perfil', 'Rótulo ou score sobre a pessoa. É tratamento. Motivo, mínimo, sem discriminar.'),
      chip('Score escondido', 'Esconder na interface não esconde na lei.'),
    ],
    [
      'Perfil é tratamento.',
      'Precisa de motivo, mínimo, sem discriminar.',
      'Score escondido ainda é perfil.',
    ],
  ),

  'rede-nebulosa:13': aula(
    'Mini-aula · IA na casa',
    'Colar pedido de cliente, ticket ou folha numa IA pública é mandar dado para um operador que a empresa não contratou. Prompt com gente de verdade é compartilhamento. Trate como tal. Use só ferramenta liberada. Dado fictício quando for demo. Pedir não treine com isso no texto do prompt não é contrato.',
    'Carla cola 50 tickets reais com nome e telefone num chat público para treinar o tom. A Padaria Estrela acabou de viajar para um planeta sem contrato. Para. Ferramenta da casa, ou gente inventada.',
    'Se a desculpa for só treino, ainda é compartilhar. Treino não é chave.',
    [
      chip('IA pública', 'Operador que a empresa não contratou. Dado de gente não cola lá.'),
      chip('Ferramenta liberada', 'A da casa, com contrato. Demo: dado fictício.'),
    ],
    [
      'Colar gente em IA pública é compartilhar.',
      'Use ferramenta liberada ou dado fictício.',
      'Prompt mágico não é contrato.',
    ],
  ),

  'rede-nebulosa:14': aula(
    'Mini-aula · menor é extra',
    'Dado de criança pede cuidado extra. Clube infantil, foto de aniversário no salão, cadastro no cardápio. Sem o responsável, sem exposição. A autoridade já mostrou que multa isso — e alto. Você não vira advogado de menor neste slide. Vira alguém que não expõe, não perfila por esporte, e chama o Encarregado se o produto puxar menor para o centro.',
    'A Padaria Estrela quer foto das crianças do aniversário no cardápio público. Para. Responsável. Sem exposição. Encarregado se isso vira produto.',
    'Se a frase for é só um cadastro fofo, este selo existe: menor = extra.',
    [
      chip('Menor = extra', 'Criança e adolescente: cuidado maior. Sem responsável, sem exposição.'),
      chip('Não é só cadastro', 'Foto de aniversário e clube infantil não são enfeite.'),
    ],
    [
      'Dado de criança pede cuidado extra.',
      'Sem responsável, sem exposição.',
      'Produto com menor no centro: Encarregado.',
    ],
  ),

  'rede-nebulosa:15': aula(
    'Mini-aula · ECA em uma frase',
    'Em 2026 a autoridade também olha regras de criança no mundo digital. Você não precisa virar advogado desse estatuto. Precisa de três gestos: não expor menor, não perfilar menor por esporte, chamar o Encarregado se o produto puxar menor para o centro. Uma aula. Não um curso de plataforma. O recado cabe nesta frase e para no seu posto.',
    'Pedro pensa num clube infantil com ranking de guloseimas por criança. Para. Isso perfila menor. Encarregado antes. Talvez nunca.',
    'Se o produto nascer com menor no cartaz, este slide já pediu o canal. Não depois do ar.',
    [
      chip('Mundo digital e menor', 'A ANPD também olha isso. Você não vira advogado. Você não expõe.'),
      chip('Uma frase', 'Não expor, não perfilar por esporte, Encarregado se menor for o centro.'),
    ],
    [
      'Não expor menor.',
      'Não perfilar menor por esporte.',
      'Menor no centro do produto: Encarregado.',
    ],
  ),

  'rede-nebulosa:16': aula(
    'Recap · mini-aula 2',
    'Decisão de máquina tem revisão. Perfil é tratamento. IA pública não é pasta da empresa. Menor é extra. Em dúvida, Encarregado. Isto fecha a segunda nebula. O quiz cobra o robô na porta e o ticket colado no chat público.',
    'Ana encaminha a revisão. Carla não cola o ticket. Pedro não perfila a criança. Recap no posto.',
    'A frase de bolso: gente revisa gente. Menor, extra.',
    [
      chip('Quatro pedras', 'Revisão humana, perfil, IA da casa, menor extra.'),
      chip('Em dúvida', 'Encarregado. Sempre cabe.'),
    ],
    [
      'Decisão de máquina tem revisão humana.',
      'Perfil e IA pública são tratamento / compartilhamento.',
      'Menor = extra; em dúvida, Encarregado.',
    ],
  ),

  'rede-nebulosa:17': aula(
    'Quiz · foi o robô',
    'Cliente pergunta por que o cadastro foi bloqueado pelo sistema. Você não diz foi o robô, não tem jeito. Encaminha para revisão humana ou canal de privacidade. Inventar um motivo para ele sair também erra. Sem lei nova: só a porta aberta.',
    'A Maria pergunta no caixa. Ana não fecha a conversa com a palavra sistema. Encaminha.',
    'Foi o robô é a Vaza de gravata. Não marca isso.',
    [
      chip('Revisão humana', 'Decisão só de máquina não fecha a porta.'),
    ],
    [],
  ),

  'rede-nebulosa:18': aula(
    'Quiz · ticket na IA',
    'Colar 50 tickets reais com nome e telefone numa IA pública não é só treino. É compartilhar dado pessoal com quem a empresa não contratou. Pedir no prompt para não treinar não é contrato. Dado fictício ou ferramenta liberada. Sem artigo novo.',
    'Carla quase cola os tickets da Padaria Estrela. Troca por conversas inventadas. Ou pela ferramenta da casa.',
    'A opção certa recusa o chat público. A mágica no prompt não salva.',
    [
      chip('IA pública', 'Sem contrato da empresa, dado de gente não cola.'),
    ],
    [],
  ),

  'rede-nebulosa:19': aula(
    'Caso · a nebula vaza',
    'Segunda, 9h. Um fornecedor de disparo com servidor fora do Brasil avisa: lista de 12 mil clientes da Padaria Estrela vazou. Tem menor no clube infantil. O CSV saiu de um e-mail pessoal de um colega. Quatro fichas, um caso. Você não é o porta-voz. No próximo slide, a sua ordem. Agora, só reconhecer a cena: transferência, volume, menor, atalho pessoal. A Vaza foi convidada.',
    'Rico reconhece o e-mail da casa no cabeçalho. Carla vê nomes de criança. Pedro vê o fornecedor longe. Os três param o feeling. Entram no roteiro.',
    'Se um caso desses chegar no seu turno, esta tela já aconteceu. A ordem vem agora.',
    [
      chip('Quatro fichas', 'Fornecedor fora, 12 mil, menor, e-mail pessoal.'),
      chip('Convite', 'O CSV saiu de um atalho. A Vaza não precisou arrombar.'),
    ],
    [
      'Reconhecer o caso: fora do Brasil, volume, menor, e-mail pessoal.',
      'Você não é porta-voz.',
      'O relógio da empresa já acordou.',
    ],
  ),

  'rede-nebulosa:20': aula(
    'Caso · a sua ordem',
    'A sua ordem cabe em quatro passos. Avisa segurança e Encarregado agora. Não reenvia o CSV. Conta como o arquivo saiu, se você souber. Para de usar o fornecedor até o time falar. O relógio de 3 dias úteis já corre para a empresa. Você não avisa os 12 mil pelo Gmail da casa. Isso seria o segundo convite.',
    'Carla quer ser rápida e quase escreve para os 12 mil. Rico segura: fluxo oficial. Pedro desliga o disparo até o Encarregado falar.',
    'Alarme, não megafone. Cofre, não viral. Isto é o seu papel no caso.',
    [
      chip('Quatro passos', 'Avisa, não reenvia, conta o caminho, para o fornecedor.'),
      chip('Relógio', '3 dias úteis da empresa. Você aciona agora. Não discursa.'),
    ],
    [
      'Avisar segurança e Encarregado agora.',
      'Não reenviar o CSV; contar como saiu.',
      'Parar o fornecedor até o time falar.',
    ],
  ),

  'rede-nebulosa:21': aula(
    'Mini-aula · número verdadeiro',
    'A lei não é lenda. Pode haver advertência. Multa de até 2% do faturamento no Brasil, com teto de R$ 50 milhões por infração. Publicação. Bloqueio. E, depois de certas sanções no mesmo caso, até suspender atividade. Não é o valor da Altec neste slide. É a escala verdadeira. Sem pânico inventado. Sem achar que ninguém multa.',
    'Alguém no café diz a ANPD não multa de verdade. Você já tem o número. Teto por infração. 2% no Brasil. Sem lenda.',
    'O número existe para caber na cabeça, não para assustar o turno. Cuidado no posto vale mais que medo no poster.',
    [
      chip('Teto por infração', 'Até 2% do faturamento no Brasil, teto R$ 50 milhões por infração.'),
      chip('Outras sanções', 'Advertência, publicação, bloqueio, e, depois, até suspender atividade.'),
    ],
    [
      'Multa: até 2% no Brasil, teto R$ 50 milhões por infração.',
      'Também há advertência, publicação, bloqueio.',
      'Não é lenda; não é o valor da sua folha.',
    ],
  ),

  'rede-nebulosa:22': aula(
    'Mini-aula · a multa no jornal',
    'Em agosto de 2026 a autoridade publicou uma multa de primeira instância de R$ 153,7 milhões ao TikTok, por falha com criança e adolescente. Ainda cabe recurso. Não é trânsito em julgado. Não é analogia de valor para a Altec. É o recado: a Agência multa, e menor pesa. Você não usa este número para assustar o caixa. Usa para não tratar menor como cadastro fofo.',
    'A Padaria Estrela não é uma plataforma daquele tamanho. Mesmo assim, foto de criança no cardápio sem responsável já era extra no slide 14. Este jornal só confirma o peso.',
    'Primeira instância. Cabe recurso. Sem analogia de valor. Três travas na boca, sempre.',
    [
      chip('Primeira instância', 'Ainda cabe recurso. Não é o final do caso.'),
      chip('Sem analogia', 'O valor não se cola na Altec. O recado sim: menor pesa, a Agência multa.'),
    ],
    [
      'A Agência multa de verdade.',
      'Aquele caso é primeira instância e cabe recurso.',
      'Não analogia de valor; menor pesa.',
    ],
  ),

  'rede-nebulosa:23': aula(
    'Mini-aula · prova, não poster',
    'Política de verdade, gente treinada, registro de quem fez este curso: isso a empresa pode mostrar. Ranking de badge no Slack, não. Este certificado é prova interna: quem, quando, o quê, se passou. Não é diploma da ANPD. Não substitui Encarregado, RIPD nem contrato de operador. Boas práticas não são poster. São hábito e papel que se prova.',
    'Ana tem o certificado. Rico tem o hábito da tela. Pedro tem o Encarregado no projeto da catraca. Três provas. Zero ranking.',
    'Se alguém vender conformidade com figurinha, você já sabe: who, when, what, pass. O resto é enfeite.',
    [
      chip('Prova interna', 'Who, when, what, pass-fail. Serve à casa. Não credencia na ANPD.'),
      chip('Não substitui', 'Nem RIPD, nem contrato, nem Encarregado. Curso é medida educativa.'),
    ],
    [
      'Certificado é prova interna, não diploma da ANPD.',
      'Badge e ranking não comprovam conformidade.',
      'Curso não substitui Encarregado nem RIPD.',
    ],
  ),

  'rede-nebulosa:24': aula(
    'Recap · mini-aula 3',
    'No caso: avisa, não espalha, para o sangramento. Multa é real, teto por infração. Menor pesa. Certificado é prova, não diploma da ANPD. Isto fecha a nebula. A última prova cobra o Gmail dos 12 mil e o número verdadeiro. Depois, os três cursos numa tela.',
    'Carla não manda o Gmail. Pedro cita 2% e R$ 50 milhões por infração, sem analogia do jornal. Rico não reenvia o CSV. Recap no posto.',
    'A frase de bolso: alarme, não megafone.',
    [
      chip('Recap do caso', 'Avisa, não reenvia, para o fornecedor. Relógio da empresa.'),
      chip('Prova, não diploma', 'Interno Altec. Sem carimbo da Agência.'),
    ],
    [
      'No caso: avisa, não espalha, para o sangramento.',
      'Teto por infração; menor pesa.',
      'Certificado é prova interna, não diploma da ANPD.',
    ],
  ),

  'rede-nebulosa:25': aula(
    'Quiz · Gmail dos 12 mil',
    'Avisar os 12 mil pelo Gmail pessoal para ser rápido vaza de novo. Comunicação de incidente é fluxo oficial. Mandar só para os menores também erra: ainda é megafone sem canal. Prazo curto não autoriza o segundo convite. Sem lei nova.',
    'O colega da Padaria Estrela já tem o Gmail aberto. Você segura o braço. Encarregado conduz.',
    'Rápido e errado ainda é errado. A opção certa é o fluxo.',
    [
      chip('Fluxo oficial', 'Quem fala com os 12 mil é o canal da empresa, não o Gmail da casa.'),
    ],
    [],
  ),

  'rede-nebulosa:26': aula(
    'Quiz · o teto da multa',
    'A frase verdadeira: pode chegar a 2% do faturamento no Brasil, até R$ 50 milhões por infração. A Agência multa de verdade. Não exige morto. Sem lenda e sem pânico inventado. É o número da volta 3.',
    'No café, alguém diz que nunca multa. Você marca a opção do teto por infração. Sem analogia do jornal.',
    'Se a opção for só multa se tiver morto, é lenda. Não marca.',
    [
      chip('Por infração', '2% no Brasil, teto R$ 50 milhões. Número verdadeiro.'),
    ],
    [],
  ),

  'rede-nebulosa:27': aula(
    'Tarefa · quatro passos',
    'Os quatro primeiros passos do caso: avisar segurança e Encarregado, não reenviar o CSV, contar como o arquivo saiu, parar o fornecedor até o time falar. Postar no grupo da loja, mandar pelo Gmail pessoal e esperar a imprensa ficam de fora. Alarme, não megafone. Sem lei nova.',
    'Rico marca os quatro do roteiro. Não marca o grupo, o Gmail, a imprensa. A Padaria Estrela respira.',
    'Se marcar o megafone, volta à ordem: aciona, não discursa.',
    [
      chip('Alarme, não megafone', 'Avisa o canal. Não viraliza. Não espera jornal.'),
    ],
    [],
  ),

  'rede-nebulosa:28': aula(
    'Fecha · os três cursos',
    'Três missões, uma trilha. Escudo: o que é dado e quem é o dono. Cofre: sensível, senha, 3 dias úteis. Nebulosa: fluxo, nuvem, máquina, menor, multa. Você carrega os três. O papel daqui a dois slides prova who, when, what, pass. Interno. Sem carimbo da ANPD. A Vaza continua procurando planilha. Não entrega.',
    'Ana, Carla, Rico, Pedro, Marina: cinco postos, três cursos. O hábito é o que o cliente da Padaria Estrela sente. O PDF é o que a casa guarda.',
    'Se uma linha ficar: encaminha, avisa, não exporta a base toda.',
    [
      chip('Três missões', 'Escudo, cofre, nebula. Dado, alarme, fluxo.'),
      chip('Prova da trilha', 'Interna. Recert daqui a um ano. Sem diploma da Agência.'),
    ],
    [],
  ),

  'rede-nebulosa:29': aula(
    'Hábitos · cartão de bolso',
    'Cartão de bolso. Bloqueia a tela. Não manda dado no grupo. Não cola gente em IA pública. Não exporta a base toda. Pedido de titular e vazamento: encaminha agora. Menor: extra. Em dúvida: Encarregado. Sete frases. Cabem no crachá. A Vaza odeia crachá assim.',
    'Ana trava. Carla não cola. Rico não exporta. Pedro chama o Encarregado. Marina encaminha o pedido da Maria. Cartão vivo.',
    'Leva as sete para o turno de amanhã. O certificado só assina o que o hábito já fez.',
    [
      chip('Cartão de bolso', 'Tela, grupo, IA, base, encaminha, menor, Encarregado.'),
      chip('Em dúvida', 'Encarregado. A frase que cabe em qualquer posto.'),
    ],
    [],
  ),

  'rede-nebulosa:30': aula(
    'Certificado · trilha interna',
    'Missão completa. Três certificados, um da trilha. Diz quem fez, quando fez, o que cobriu e se passou. É prova interna da Altec. Não é carimbo da ANPD. Não credencia Encarregado. Daqui a um ano a gente se vê no recert. Até lá, a Vaza continua procurando planilha. Não entrega. Eu, Teca, fico no bolso: em dúvida, encaminha.',
    'A Padaria Estrela abre na terça com tela bloqueada, sem CSV no Gmail, sem menor no cardápio sem responsável. O PDF dorme na pasta. O hábito abre a loja.',
    'Who, when, what, pass. O resto é o seu posto, amanhã.',
    [
      chip('Certificado da trilha', 'Prova interna who / when / what / pass-fail. Sem credenciamento da ANPD.'),
      chip('Recert', 'Daqui a um ano. Até lá, o cartão de bolso trabalha.'),
    ],
    [],
  ),
};
